import { AccessTime } from "@mui/icons-material";
import {
  Alert,
  Divider,
  Grid,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { ScheduleMeeting } from "react-schedule-meeting";
import { API_URL } from "../../../../configs/endpoint";

export default function PickTime({ control, watch, setValue, handleNext }) {
  const [apiResponse, setApiResponse] = useState({
    loading: false,
    error: null,
    data: null,
  });

  const slotSectionRef = useRef(null); // 👈 ref for slots section
  const doctorId = watch("doctor") || null;
  const patientId = watch("patient") || null;
  const startTime = watch("startTime");
  const fetchFromPatient = async (pid) => {
    try {
      setApiResponse({ loading: true, error: null, data: null });
      // 🔎 Step 1: get patient details
      const patientRes = await axios.get(`${API_URL}/patients/${pid}`);

      const assignedDoctorId = patientRes?.data?.assignedTo;
      if (!assignedDoctorId) {
        setApiResponse({
          loading: false,
          error: "No doctor assigned to this patient.",
          data: null,
        });
        return;
      }
      setValue("doctor", assignedDoctorId);
      // console.log("patient res = ", patientRes);
      // console.log("assignedDoctorId = ", assignedDoctorId);

      // // 🔎 Step 2: use doctor id to fetch slots
      // fetchDoctorSlots(assignedDoctorId);
    } catch (error) {
      // console.log("error = ", error);
      setApiResponse({
        loading: false,
        error:
          error?.response?.data?.error || "Failed to fetch patient's doctor.",
        data: null,
      });
    }
  };

  const fetchDoctorSlots = (id) => {
    setApiResponse({ loading: true, error: null, data: null });
    axios
      .get(`${API_URL}/time-slots/${id}`)
      .then((response) => {
        var final = response.data.available_slots.map((item, index) => ({
          id: index,
          startTime: new Date(item[0]),
          endTime: new Date(item[1]),
        }));
        setValue("timeSlot", response?.data?.doctor_data?.timeSlot);
        setApiResponse({
          loading: false,
          error: null,
          data: {
            available_slots: final,
            doctor_data: response?.data?.doctor_data,
          },
        });
      })
      .catch((error) => {
        // console.log("error v= ", error);
        setApiResponse({
          loading: false,
          error:
            error?.response?.data?.error ||
            "Failed to fetch doctor's available slots.",
          data: null,
        });
      });
  };
  useEffect(() => {
    if (doctorId) {
      fetchDoctorSlots(doctorId);
    } else if (patientId) {
      fetchFromPatient(patientId);
    }
  }, [doctorId, patientId]);
  if (apiResponse?.error) {
    return <Alert severity="error">{apiResponse.error}</Alert>;
  }
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} lg={4}>
        {apiResponse.loading ? (
          <>
            <Skeleton variant="text" width="80%" height={40} />
            <Skeleton variant="text" width="60%" />
            <Divider sx={{ my: 2 }} />
            <Skeleton variant="rectangular" width="100%" height={40} />
            <Skeleton variant="text" width="90%" sx={{ mt: 3 }} />
            <Skeleton variant="text" width="50%" sx={{ mt: 4 }} />
            <Skeleton variant="text" width="30%" height={40} />
          </>
        ) : (
          <>
            <Typography variant="h5" color="secondary" fontWeight={600}>
              {apiResponse?.data?.doctor_data?.name}
            </Typography>
            <Typography variant="subtitle2" color="text.secondary">
              {apiResponse?.data?.doctor_data?.speciality}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Stack direction={"row"} alignItems="center" gap={1}>
              <AccessTime />
              <Typography variant="body1" fontWeight={600}>
                {apiResponse?.data?.doctor_data?.timeSlot} minutes
              </Typography>
            </Stack>
            <Typography variant="body1" sx={{ mt: 3 }}>
              Have questions about your condition? No problem! We're happy to
              help and can walk you through any concerns you may have.
            </Typography>

            <Typography
              variant="body1"
              color="secondary"
              sx={{ mt: 4, fontWeight: 600, lineHeight: 1 }}
            >
              Consultation Fee
            </Typography>
            {/* <Typography sx={{ fontSize: "32px", fontWeight: 600 }}>
              $20
            </Typography>
            <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
              OR
            </Typography> */}
            <Typography sx={{ fontSize: "32px", fontWeight: 600 }}>
              {/* {apiResponse?.data?.doctor_data?.consultationFee} PKR{" "} */}
              {apiResponse?.data?.doctor_data?.name ===
                "Shahbaz Khalid Ranjha" ?    "$20"
              :apiResponse?.data?.doctor_data?.consultationFee + " PKR"
              }
            </Typography>
          </>
        )}
      </Grid>

      <Grid
        item
        xs={12}
        lg={8}
        sx={{
          pt: "0 !important",
          "& .go695645437": { margin: 0, padding: 0 },
          "& .go4247048326.react-calendar": { minHeight: "fit-content" },
        }}
      >
        {apiResponse.loading ? (
          <Skeleton variant="rectangular" width="100%" height={400} />
        ) : (
          <ScheduleMeeting
            style={{ boxShadow: "none", padding: 0, margin: 0 }}
            borderRadius={10}
            primaryColor="#090"
            eventDurationInMinutes={apiResponse?.data?.doctor_data?.timeSlot}
            availableTimeslots={apiResponse?.data?.available_slots}
            selectedStartTime={startTime ? new Date(startTime) : null} // 👈 preselects from form
            onSelectedDayChange={() => {
              console.log("scroll"); // ✅ should log now
              if (window.innerWidth < 500 && slotSectionRef.current) {
                slotSectionRef.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
            }}
            onStartTimeSelect={(e) => {
              setValue("startTime", e.startTime.toString());
              handleNext();
            }}
            startTimeListStyle={
              window.innerWidth < 500 ? "grid" : "scroll-list"
            }
          />
        )}

        {/* 👇 custom wrapper for slots */}
        <div
          ref={slotSectionRef}
          style={{ height: 0, overflow: "hidden" }}
          className="slot-anchor"
        />
      </Grid>
    </Grid>
  );
}
